import { FC } from 'react'

import styles from './dashboardLayout.module.scss'

export const DashboardLayout: FC = ({ children }) => (
  <div>
    <div className={styles['dashboard-content']}>{children}</div>
  </div>
)
